"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var calculateGrossPriceForFreeOffer = function calculateGrossPriceForFreeOffer(netPrice, taxRate, customerPriceInclTax) {
  var grossPrice = netPrice + taxRate * netPrice;
  var shouldRoundGrossPrice = customerPriceInclTax === Number(grossPrice.toFixed(2));
  if (shouldRoundGrossPrice) {
    return grossPrice.toFixed(2);
  }
  // required to handle price edge cases
  return (Math.trunc(grossPrice * 100) / 100).toFixed(2);
};
var _default = calculateGrossPriceForFreeOffer;
exports.default = _default;